// @flow
import React from 'react';
import { Container, Tabs } from 'components';

const GetStartedEdit = () => {
  return (
    <Container.Tab>
      <Tabs />
    </Container.Tab>
  );
};

export default GetStartedEdit;
